const AsyncLoader = ({ loading, error, children }) => {
  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center text-danger py-5">
        {error}
      </div>
    );
  }

  return children;
};

export default AsyncLoader;
